import { ReactNode } from 'react';
import { Sheet } from 'react-modal-sheet';
interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  heightFit?: boolean;
  modalZIndex?: number;
}
const SlidingModal = ({
  children,
  isOpen,
  onClose,
  heightFit,
  modalZIndex
}: Props) => {
  return <Sheet isOpen={isOpen} onClose={() => onClose?.()} disableDrag={onClose ? false : true} detent={heightFit ? 'content-height' : 'full-height'} style={{
    zIndex: 9999 + (modalZIndex || 0)
  }} data-sentry-element="Sheet" data-sentry-component="SlidingModal" data-sentry-source-file="SlidingModal.tsx">
      <Sheet.Container className={`!bg-genius-pink-foreground`} data-sentry-element="unknown" data-sentry-source-file="SlidingModal.tsx">
        <Sheet.Header data-sentry-element="unknown" data-sentry-source-file="SlidingModal.tsx" />
        <Sheet.Content data-sentry-element="unknown" data-sentry-source-file="SlidingModal.tsx">{children}</Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop className='!bg-white/20' onTap={() => onClose?.()} data-sentry-element="unknown" data-sentry-source-file="SlidingModal.tsx" />
    </Sheet>;
};
export default SlidingModal;